import Prices from './Prices';
export default Prices;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/components/ListOrders/components/General/components/Prices/index.ts